export const getToken = (key: string): string | null => {
    try {
        return localStorage.getItem(key);
    } catch (error) {
        console.error("Ошибка при получении токена:", error);
        return null;
    }
};

export const saveToken = (key: string, value: string): { status: string; error?: any } => {
    try {
        localStorage.setItem(key, value);
        return { status: "success" };
    } catch (error) {
        console.error("Ошибка при сохранении токена:", error);
        return { status: "error", error };
    }
};

export const clearStorage = (): void => {
    try {
        localStorage.clear();
    } catch (error) {
        console.error("Ошибка при очистке localStorage:", error);
    }
};